
import React from 'react';

const services = [
  {
    icon: 'ri-star-smile-line',
    title: 'Cosmetic Dentistry',
    description:
      'Transform your smile with veneers, bonding, and smile makeovers at our Kondapur clinic. Expert cosmetic dentistry near Hitech City, Hyderabad.',
    gradient: 'from-teal-400 to-cyan-500',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Root Canal Treatment',
    description:
      'Painless root canal therapy in Kondapur using advanced techniques. Save your natural teeth with our expert endodontic care in Hyderabad.',
    gradient: 'from-emerald-400 to-teal-500',
  },
  {
    icon: 'ri-tooth-line',
    title: 'Dental Implants',
    description:
      'Affordable dental implants in Kondapur, Hyderabad. Permanent tooth replacement that looks and feels natural. Best implant dentist near you.',
    gradient: 'from-cyan-400 to-teal-500',
  },
  {
    icon: 'ri-align-center',
    title: 'Orthodontics & Aligners',
    description:
      'Braces and clear aligners in Kondapur for a perfect smile. Invisalign provider near Hitech City, Hyderabad with flexible payment options.',
    gradient: 'from-teal-500 to-emerald-500',
  },
  {
    icon: 'ri-contrast-2-line',
    title: 'Teeth Whitening',
    description:
      'Professional teeth whitening in Kondapur for a brighter, confident smile in just one visit. Safe and effective whitening at Sri Maruthi Teeth Empire Hyderabad.',
    gradient: 'from-sky-400 to-cyan-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Preventive Care',
    description:
      'Regular dental checkups, cleanings, and preventive treatments in Kondapur. Maintain optimal oral health at our Hyderabad dental clinic.',
    gradient: 'from-emerald-500 to-teal-600',
  },
];

export function Services() {
  return (
    <section id="services" aria-labelledby="services-heading" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
            <span className="text-sm font-semibold text-teal-600">
              Dental Services in Kondapur, Hyderabad
            </span>
          </div>
          <h2
            id="services-heading"
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Comprehensive Dental Solutions in Kondapur
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            From <strong>dental implants</strong> to{' '}
            <strong>cosmetic dentistry</strong>, Sri Maruthi Teeth Empire offers complete
            dental care on Botanical Garden Road, Kondapur, Hyderabad. Serving
            patients from Hitech City, Gachibowli, Kothaguda &amp; Masjid Banda.
          </p>
        </header>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-product-shop>
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 hover:border-teal-500 border-2 border-transparent cursor-pointer group"
            >
              <div
                className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${service.gradient} rounded-full mb-6 group-hover:scale-110 transition-transform`}
                aria-hidden="true"
              >
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <a href="#booking" className="hover:text-teal-600 transition-colors">{service.title}</a>
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <a
                href="#booking"
                className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm hover:gap-3 transition-all cursor-pointer"
                aria-label={`Book ${service.title} appointment at Sri Maruthi Teeth Empire`}
              >
                Book Now
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>

        <div className="text-center">
          <p className="text-gray-600 mb-3">
            Looking for a specific dental treatment in Kondapur?
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:gap-3 transition-all cursor-pointer border-b-2 border-teal-600"
          >
            Contact Us for All Services
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
